<template>
    <header class="card-header">
        <p class="card-header-title">
            <img :src="'/static/images/manufacturers/' +  bid.lot.company + '.png'" style="float: left; margin-right: 10px;" width="50">
            <strong class="has-text-primary" style="padding-right: 5px;">{{ bid.lot.company }}</strong><strong>{{ bid.lot.model_name }}</strong>
        </p>
        <p class="card-header-icon title is-2" style="margin-bottom: 0px;">
            <span style="margin-right: 10px;" class="has-text-danger">{{ bid.lot.scores }}</span>
            <img :src="'/static/images/auctions/' + bid.lot.auction_name  + '.png'"
                 @error="getDefaultImgSource" style="max-height: 30px; padding-right: 15px;"
                 class="is-hidden-touch">
        </p>
        <div class="card-image is-hidden-desktop">
            <figure class="image is-4by3">
                <img :src="bid.lot.pictures.split('#')[1] + '&w=320'">
            </figure>
        </div>
    </header>
</template>

<script>
    export default {
        props: ['bid'],
        methods: {
            getDefaultImgSource(element) {
                element.target.src = '/static/images/logo.png'
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/Card/Headers/BidHeader.vue